export type OperationalFocusSnapshot = {
  shiftId?: string;
  shiftDayId?: string;
  conversationId?: string;
  doctorId?: string;
  dutyId?: string;
  serviceDate?: string;
  label?: string;
  pageType?: string;
};

type Listener = (next: OperationalFocusSnapshot) => void;

type InternalSnapshot = OperationalFocusSnapshot & { owner: number };

let snapshot: InternalSnapshot = { owner: 0 };
const listeners = new Set<Listener>();

const publicSnapshot = (value: InternalSnapshot): OperationalFocusSnapshot => ({
  shiftId: value.shiftId,
  shiftDayId: value.shiftDayId,
  conversationId: value.conversationId,
  doctorId: value.doctorId,
  dutyId: value.dutyId,
  serviceDate: value.serviceDate,
  label: value.label,
  pageType: value.pageType,
});

const emit = () => {
  const next = publicSnapshot(snapshot);
  listeners.forEach((listener) => listener(next));
};

export const getOperationalFocus = () => publicSnapshot(snapshot);

export const setOperationalFocus = (next: OperationalFocusSnapshot): number => {
  snapshot = {
    owner: snapshot.owner + 1,
    shiftId: next.shiftId?.trim() || undefined,
    shiftDayId: next.shiftDayId?.trim() || undefined,
    conversationId: next.conversationId?.trim() || undefined,
    doctorId: next.doctorId?.trim() || undefined,
    dutyId: next.dutyId?.trim() || undefined,
    serviceDate: next.serviceDate?.trim() || undefined,
    label: next.label?.trim() || undefined,
    pageType: next.pageType?.trim() || undefined,
  };
  emit();
  return snapshot.owner;
};

export const clearOperationalFocus = () => setOperationalFocus({});

export const releaseOperationalFocus = (owner: number) => {
  if (snapshot.owner !== owner) return;
  snapshot = { owner: snapshot.owner + 1 };
  emit();
};

export const subscribeOperationalFocus = (listener: Listener) => {
  listeners.add(listener);
  listener(publicSnapshot(snapshot));
  return () => {
    listeners.delete(listener);
  };
};
